export function parse (str) {
  try {
    return JSON.parse(str)
  } catch (error) {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/helpers/json.js